import React, {useEffect} from 'react';
import ReportViewer from "../../rapports/base/ReportViewer";
import {Popup} from "devextreme-react/popup";
import Guid from "../../models/Guid";
import {useParams} from "react-router-dom";
import RenderInNewWindow from "../../utils/RenderInNewWindow";

interface IImpressionFactureProps {
    idFacturationEntete?: Guid,
    idMessage?: Guid,
    onClose: () => void
}

const ImpressionFacture = ({idFacturationEntete, idMessage, onClose}: IImpressionFactureProps) => {
    if (!idFacturationEntete) return null;
    return (
        <RenderInNewWindow onClose={onClose}>
            <div style={{display: "flex", justifyContent: "center", flex: 1}}>
                <ReportViewer reportName={`FactureLettreReport/${idFacturationEntete}/${idMessage}`}/>
            </div>
        </RenderInNewWindow>
    );
}
export default ImpressionFacture;